module.exports = __webpack_public_path__ + "img/icon-mute.b4cab706.svg";